import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
	ChildrenContainer,
	DetailPanel,
	Inner,
	PageHeader,
	PageSub,
	PageTitle,
	Section,
	Shell,
	Sidebar,
	SidebarBadge,
	SidebarIcon,
	SidebarItem,
	SidebarLabel,
	SidebarSectionLabel,
} from "./styles";
import Main from "../../../layout/main/Main";
import ModuleErp from "./components/module-erp/ModuleErp";
import { MdOutlineAppRegistration } from "react-icons/md";
import { GiArtificialIntelligence } from "react-icons/gi";
import { SettingOutlined } from "@ant-design/icons";
import { useAuth } from "../../../../contexts/authContext";
import { useFilter } from "../../../../contexts/filterContext";

export default function GeneralConfig({
	userdata,
	clientId,
	clientContract,
	clientName,
}) {
	const { erpSection, setErpSection } = useFilter();
	const { agentOrdersQty } = useAuth();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Main>
			<Main.Header style={{ padding: "0 82px" }}>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Configuración General
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Inner>
				<PageHeader>
					<Section>
						<PageTitle>Configuración General</PageTitle>
						<PageSub>Administrá los parámetros del sistema</PageSub>
					</Section>
				</PageHeader>

				<Shell>
					<Sidebar>
						<SidebarSectionLabel>ERP</SidebarSectionLabel>

						<SidebarItem
							$active={erpSection === "general"}
							onClick={() => setErpSection("general")}
						>
							<SidebarIcon $active={erpSection === "general"}>
								<SettingOutlined />
							</SidebarIcon>
							<SidebarLabel>Configuración General</SidebarLabel>
						</SidebarItem>

						{clientContract &&
							(clientContract.activeMobileApp ||
								clientContract.activeWebSeller) && (
								<SidebarItem
									$active={erpSection === "dynamics"}
									onClick={() => setErpSection("dynamics")}
								>
									<SidebarIcon $active={erpSection === "dynamics"}>
										<MdOutlineAppRegistration size={16} />
									</SidebarIcon>
									<SidebarLabel>Dinámicas / Ofertas</SidebarLabel>
								</SidebarItem>
							)}

						{clientContract &&
							(clientContract.activeIASuggested ||
								clientContract.activeIASeller) && (
								<SidebarItem
									$active={erpSection === "ia"}
									onClick={() => setErpSection("ia")}
								>
									<SidebarIcon $active={erpSection === "ia"}>
										<GiArtificialIntelligence size={16} />
									</SidebarIcon>
									<SidebarLabel>IA</SidebarLabel>
									{agentOrdersQty > 0 && (
										<SidebarBadge>{agentOrdersQty}</SidebarBadge>
									)}
								</SidebarItem>
							)}
					</Sidebar>

					<DetailPanel>
						<ChildrenContainer>
							<ModuleErp
								clientContract={clientContract}
								userdata={userdata}
								activeSection={erpSection}
								clientId={clientId}
							/>
						</ChildrenContainer>
					</DetailPanel>
				</Shell>
			</Inner>
		</Main>
	);
}
